import * as y from 'yup'

export const MIN_8_CHARS = /^.{8,}$/
export const ONE_UPPER = /(?=.*[A-Z])/
export const ONE_LOWER = /(?=.*[a-z])/
export const ONE_NUMBER = /(?=.*\d)/

export const PASSWORD_RULES = [
  { regex: MIN_8_CHARS, key: 'ruleMinEightChars' },
  { regex: ONE_UPPER, key: 'ruleOneUpper' },
  { regex: ONE_LOWER, key: 'ruleOneLower' },
  { regex: ONE_NUMBER, key: 'ruleOneNumber' },
] as const

export type PasswordRuleText = Record<(typeof PASSWORD_RULES)[number]['key'], string>

export const passwordFieldRules = y
  .string()
  .matches(MIN_8_CHARS, 'password.invalid')
  .matches(ONE_UPPER, 'password.invalid')
  .matches(ONE_LOWER, 'password.invalid')
  .matches(ONE_NUMBER, 'password.invalid')

export const passwordSchema = y.object({
  password: passwordFieldRules.optional(),
})

export type PasswordSchema = y.InferType<typeof passwordSchema>
